import React from "react";

export default function JS_Class() {
  return (
    <div className="tutorial-container">
      <h1>JS Class</h1>
      <p>This tutorial explains the concept of JS Class in JavaScript OOPs.</p>
    </div>
  );
}
